export const ROUND_END = 'END';
export const ROUND_PAUSE = 'PAUSE';

export const ROUND_STATUS_WON = 'WON';
export const ROUND_STATUS_LOST = 'LOST';

// Header - Dimensioni e stili
export const HEADER_HEIGHT = 90;
export const HEADER_COLOR = 0x1567a3;
export const HEADER_TITLE_SIZE = 56;
export const HEADER_TITLE_COLOR = '#FFFFFF';

// GameTab - Dimensioni e stili
export const GAME_TAB_BUTTON_TEXT = 34;
export const GAME_TAB_HEIGHT = 60;
export const GAME_TAB_COLOR_SELECTED = 0x2a7a9a;
export const GAME_TAB_COLOR_UNSELECTED = 0x1a5a7a;
export const GAME_TAB_BORDER_SELECTED = 0xffd700;
export const GAME_TAB_BORDER_UNSELECTED = 0x2a7a9a;
export const GAME_TAB_TEXT_SELECTED = '#FFD700';
export const GAME_TAB_TEXT_UNSELECTED = '#FFFFFF';
